import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

import { Subscription } from 'rxjs';

import { TmtLoggerService } from 'tmt-logger';

import { RequirementWithTestAnalysis } from 'src/models/requirement';
import { environment } from 'src/environments/environment';
import { RequirementBaseService } from 'src/services/requirement.base.service';

@Component({
	selector: 'app-requirements',
	templateUrl: './requirements.component.html',
	styleUrls: ['./requirements.component.scss'],
})
export class RequirementsComponent implements OnChanges, OnDestroy {
	requirementsByTestCase: RequirementWithTestAnalysis[];

	requirementsByResult: RequirementWithTestAnalysis[];

	@Input() testCaseName: string;

	@Input() testCaseUid: string;

	@Input() testCaseVersion: number;

	@Input() testResultUid: string;

	@Output() countRequirements: EventEmitter<any> = new EventEmitter();

	private subscription: Subscription;

	dataSource: MatTableDataSource<RequirementWithTestAnalysis>;

	displayedColumns: string[] = ['requirement.requirementId', 'requirement.version', 'requirement.asil', 'requirement.name'];

	displayedColumnsTA: string[] = ['testAnalysis.name', 'testAnalysis.version', 'testAnalysis.uid', 'testAnalysis.regTime', 'testAnalysis.validTo'];

	displayedColumnsTAAlt: string[] = [
		'testAnalysisAlternative.name',
		'testAnalysisAlternative.version',
		'testAnalysisAlternative.uid',
		'testAnalysisAlternative.regTime',
		'testAnalysisAlternative.validTo',
	];

	requirementsurl = environment.requirementsurl;

	labelShowAll: string;

	reqIsResult: boolean;

	constructor(
		private requirementBaseService: RequirementBaseService,
		private loggerService: TmtLoggerService,
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		this.getRequirements(this.testCaseUid, this.testCaseVersion, this.testResultUid);
		this.labelShowAll = 'Show all requirements connected to ' + this.testCaseName + ' (version ' + this.testCaseVersion + ')';
	}

	private getRequirements(caseUid: string, caseVersion: number, resultUid: string) {
		this.requirementsByTestCase = null;
		this.requirementsByResult = null;
		(this.subscription = this.requirementBaseService.getRequirementsByResult(resultUid).subscribe(resultReq => {
			this.requirementsByResult = resultReq;
			this.countRequirements.emit(this.requirementsByResult.length);
			this.dataSource = new MatTableDataSource<RequirementWithTestAnalysis>(this.requirementsByResult);
			if (this.requirementsByResult.length > 0) {
				this.requirementsByResult.forEach(r => {
					r.isResultRequirement = true;
				});
			}
			this.requirementBaseService.getRequirementsByTestCase(caseUid, caseVersion).subscribe(tcReq => {
				this.requirementsByTestCase = tcReq;
			});
		})),
			error => this.loggerService.logError(error);
	}

	public showHistory(isChecked: boolean) {
		if (isChecked) {
			this.requirementsByTestCase.forEach(req => {
				req.isResultRequirement = false;
				const found = this.requirementsByResult.some(r => {
					if (
						r.requirement.requirementId === req.requirement.requirementId &&
						r.requirement.asil === req.requirement.asil &&
						r.requirement.version === req.requirement.version &&
						r.testAnalysis.uid === req.testAnalysis.uid &&
						r.testAnalysis.version === req.testAnalysis.version &&
						r.testAnalysisAlternative.uid === req.testAnalysisAlternative.uid &&
						r.testAnalysisAlternative.version === req.testAnalysisAlternative.version
					) {
						req.isResultRequirement = true;
					}
				});
				this.dataSource = new MatTableDataSource<RequirementWithTestAnalysis>(this.requirementsByTestCase);
				this.countRequirements.emit(this.requirementsByTestCase.length);
			});
		} else {
			this.dataSource = new MatTableDataSource<RequirementWithTestAnalysis>(this.requirementsByResult);
			this.countRequirements.emit(this.requirementsByResult.length);
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}
}
